import { DETERMINAR_PAGINA_ATUAL_CIDADE } from '../../actions/types'

const initialState = undefined

export default function (state = 1, action = initialState) {
  switch (action.type) {
    case DETERMINAR_PAGINA_ATUAL_CIDADE: {
      return action.payload
    }

    default:
      return state
  }
}
